var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.question && _vm.$auth.user().id === _vm.question.consultant_id)?_c('solution-consultant',{attrs:{"question":_vm.question}}):(_vm.question)?_c('solution-expert',{attrs:{"question":_vm.question}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61e17a90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatSolution/Solution.vue
// module id = null
// module chunks = 